/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconMoodNervous = createReactComponent("mood-nervous", "IconMoodNervous", [
  ["path", { d: "M12 12m-9 0a9 9 0 1 0 18 0a9 9 0 1 0 -18 0", key: "svg-0" }],
  ["path", { d: "M9 10h.01", key: "svg-1" }],
  ["path", { d: "M15 10h.01", key: "svg-2" }],
  ["path", { d: "M8 16l2 -2l2 2l2 -2l2 2", key: "svg-3" }]
]);

export { IconMoodNervous as default };
//# sourceMappingURL=IconMoodNervous.js.map
